import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api/axios';
import '../styles/Likes.css';

export default function LikesPage() {
  const [likes, setLikes] = useState([]);
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState({});
  const [matchModal, setMatchModal] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    API.get('/api/likes/received')
      .then((res) => {
        setLikes(res.data.likes || []);
        setIsPremium(res.data.is_premium);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSwipe = async (e, userID, direction) => {
    e.stopPropagation();
    setActionLoading((prev) => ({ ...prev, [userID]: true }));
    try {
      const res = await API.post('/api/swipes', {
        target_id: userID,
        direction,
      });
      if (res.data.matched && direction === 'like') {
        setMatchModal(likes.find((l) => l.user_id === userID));
      }
      setLikes((prev) => prev.filter((l) => l.user_id !== userID));
    } catch (err) {
      if (err.response?.status === 403) {
        navigate('/premium');
        return;
      }
      console.error('Swipe failed:', err);
    } finally {
      setActionLoading((prev) => ({ ...prev, [userID]: false }));
    }
  };

  if (loading) {
    return (
      <div className="likes-page">
        <header className="likes-header"><h1>Liked You</h1></header>
        <div className="likes-loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="likes-page">
      <header className="likes-header">
        <h1>Liked You</h1>
        {likes.length > 0 && (
          <span className="likes-count">{likes.length}</span>
        )}
      </header>

      {!isPremium && likes.length > 0 && (
        <div className="likes-upgrade-banner">
          <p>🔒 Upgrade to Godly+ to see who liked you</p>
          <button onClick={() => navigate('/premium')}>Upgrade</button>
        </div>
      )}

      {likes.length === 0 ? (
        <div className="likes-empty">
          <p>No likes yet.</p>
          <p className="likes-empty-sub">Keep swiping to get noticed!</p>
        </div>
      ) : (
        <div className="likes-grid">
          {likes.map((like) => (
            <div
              key={like.user_id}
              className={`like-card ${like.is_blurred ? 'blurred' : ''}`}
            >
              <div
                className="like-photo-wrapper"
                onClick={() => {
                  if (like.is_blurred) {
                    navigate('/premium');
                  } else {
                    navigate(`/users/${like.user_id}`);
                  }
                }}
              >
                {like.photo_url ? (
                  <img
                    src={like.photo_url}
                    alt=""
                    className={like.is_blurred ? 'blurred-img' : ''}
                  />
                ) : (
                  <div className="like-no-photo">?</div>
                )}
                {like.is_blurred && (
                  <div className="like-blur-overlay">
                    <span>🔒</span>
                  </div>
                )}
              </div>

              <div className="like-info">
                <span className="like-name">{like.full_name}</span>
                {like.age > 0 && (
                  <span className="like-age">{Math.floor(like.age)}</span>
                )}
              </div>

              {like.denomination && (
                <span className="like-badge">{like.denomination}</span>
              )}

              {!like.is_blurred && (
                <div className="like-actions">
                  <button
                    className="like-btn dislike"
                    onClick={(e) => handleSwipe(e, like.user_id, 'pass')}
                    disabled={actionLoading[like.user_id]}
                    aria-label="Pass"
                  >
                    ✕
                  </button>
                  <button
                    className="like-btn like"
                    onClick={(e) => handleSwipe(e, like.user_id, 'like')}
                    disabled={actionLoading[like.user_id]}
                    aria-label="Like back"
                  >
                    ♥
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {matchModal && (
        <div className="match-modal-overlay" onClick={() => setMatchModal(null)}>
          <div className="match-modal" onClick={(e) => e.stopPropagation()}>
            <h2>It's a Match! 🎉</h2>
            <p>You and {matchModal.full_name} liked each other!</p>
            {matchModal.photo_url && (
              <img src={matchModal.photo_url} alt="" className="match-modal-photo" />
            )}
            <div className="match-modal-actions">
              <button
                className="match-btn secondary"
                onClick={() => setMatchModal(null)}
              >
                Keep browsing
              </button>
              <button
                className="match-btn primary"
                onClick={() => navigate('/matches')}
              >
                See matches
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}